const getData = async function (currUrl, currMethod, currHeaders, currData = ''){
    let response;
    if(currData !== ''){
        response = await fetch(`${currUrl}`,{
        method: currMethod,
        body: JSON.stringify(currData),
        headers: currHeaders
        })
    }else{
        response = await fetch(`${currUrl}`,{
        method: currMethod,
        headers: currHeaders
        })
    }
    const responseJSON = await response.json();
    return responseJSON ;
}

function formatNumberMXN(value) {
    if (isNaN(value)) return "0.00";
    return Number(value).toLocaleString("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}


let offset = 0;
const limit = 20;
let loading = false;
let allLoaded = false;

async function getProducts(customParams, currEv, currActiveOffer) {

    if(currEv == "click"){
        allLoaded = false;
    }
    if (loading || allLoaded) return;

    loading = true; 
    $("#loading-message").show();
    $("#no-more-images").hide();

    try {
        const headers = {
            'Content-type': 'application/json'
        };
        
        if(currEv == "click"){
            offset = 0;
            $("#custom-products-dimeint").html("");
        }
        const response = await getData(`/apps/folders?type=${customParams}&offset=${offset}&limit=${limit}`, 'GET', headers, '');

        if (!response.hits || response.hits.length === 0) {
            allLoaded = true;
            if (offset === 0) {
                $("#custom-products-dimeint").append(`Sin resultados`);
            } else {
                $("#no-more-images").show();
            }
            $("#loading-message").hide();
            return;
        }

        let availableCount = 0;

        let userType = $("#customer_type_custom").val();
    
        response.hits.forEach(product => {

            let currvariants = JSON.parse(product.variants);
            let currPrice = ``;
            let soldOut = ``;
            let onSale = ``;
            let buttonShop = `<a class="add product-popup-link"
                data-fancybox data-type="ajax"
                data-sku="${product.sku}"
                data-src="/products/${product.handle}?view=popup" 
                >
                    Añadir al carrito
                </a>`;
            let badgeInventoryQuantity = ``;

            let finalPrice = product.Precio || currvariants[0].price;

            if(userType){
                if (product.hasOwnProperty(userType)) {
                    if(product[userType]){
                        finalPrice = product[userType];
                    }
                }
            }
            

            if(currvariants[0].compareAtPrice){
                currPrice = `<a  class="price product-popup-link" 
                    data-fancybox data-type="ajax"
                    data-sku="${product.sku}"
                    data-src="/products/${product.handle}?view=popup">
                    <span class="price_sale">$${formatNumberMXN(currvariants[0].compareAtPrice)}</span>
                    <span class="price_regular">$${formatNumberMXN(finalPrice)}</span>
                </a>`;
                onSale = ` <span class="sale">En oferta</span>`;
            }else{
                currPrice = `<a class="price product-popup-link" 
                    data-fancybox data-type="ajax"
                    data-sku="${product.sku}"
                    data-src="/products/${product.handle}?view=popup">
                    <span class="price_regular">$${formatNumberMXN(finalPrice)}</span>
                </a>`; 
            }

            // esto es para el sold out
            if(Number(currvariants[0].inventoryQuantity) > 0){
                availableCount++;
                badgeInventoryQuantity = `<span class="badge-inventory-quantity">${currvariants[0].inventoryQuantity} en existencia</span>`;
            }else{
                soldOut = `<span class="sold">Agotado</span>`;
                buttonShop = `<a  class="soldout product-popup-link"
                    data-fancybox data-type="ajax"
                    data-sku="${product.sku}"
                    data-src="/products/${product.handle}?view=popup" 
                    >
                    Agotado
                </a>`;
                //return;
            }
            
            const templateItem = `<div class="custom-products-dimeint__item">
                <a class="product-popup-link" 
                    data-fancybox data-type="ajax"
                    data-sku="${product.sku}"
                    data-src="/products/${product.handle}?view=popup" 
                    >
                    <img src="${product.image_src}" alt="${product.title}" width="" height="">
                ${badgeInventoryQuantity}  
                ${onSale}
                ${soldOut}
                </a>
                ${currPrice}
                <a class="description product-popup-link" 
                    data-fancybox data-type="ajax"
                    data-sku="${product.sku}"
                    data-src="/products/${product.handle}?view=popup" >
                   ${product.title} <br />
                   <span>${product.marca}</span>
                   <small>
                   SKU: ${product.sku}
                   </small>
                </a>
            </div> `;

            if ($(window).width() <= 1024) {
                if(currEv == "click"){
                    $("body").removeClass("active-categories-custom");
                    $(".mobile-nav-close").trigger("click");
                }
            }

            $("#custom-products-dimeint").append(templateItem);


            $(".custom-message-only-promos").hide();
            if (customParams.includes('remates=1')) {
                $(".custom-message-only-promos").show();
            }
        });


        offset += limit;
        /*if (availableCount === 0) {
            $("#custom-products-dimeint").append(`Sin resultados`);
        }*/
    } catch (err) {
       $("#custom-products-dimeint").html(`Error al cargar los productos`);
    } finally {
       loading = false;
       $("#loading-message").hide();
    }
}

async function getProductsSearch(customParams, currEv) {

    $("#custom-all-productst").remove();
    const headers = {
        'Content-type': 'application/json'
    };
    
    
    const response = await getData(`/apps/folders?type=${customParams}&offset=${0}&limit=${5}`, 'GET', headers, '');

    if (!response.hits || response.hits.length === 0) {
        $("form.live-search-form .search-flydown .search-flydown--results").html("No se encontraron resultados");
        console.log("sin resultados en el buscador ")
        return;
    }else{
        console.log("si hay en el buscador ")
        $("form.live-search-form .search-flydown .search-flydown--results").html("");
        console.log($("form.live-search-form .search-flydown .search-flydown--results").length)
        
        $("form.live-search-form .search-flydown").append(`<a href="#" id="custom-all-productst">Ver todos</a>`);
    }

    let availableCount = 0;

    let userType = $("#customer_type_custom").val();

    response.hits.forEach(product => {

        let currvariants = JSON.parse(product.variants);
        let currPrice = ``;
        let soldOut = ``;
        let onSale = ``;
        let badgeInventoryQuantity = ``;

        let finalPrice = product.Precio || currvariants[0].price;

        if(userType){
            if (product.hasOwnProperty(userType)) {
                if(product[userType]){
                    finalPrice = product[userType];
                }
            }
        }
        

        if(currvariants[0].compareAtPrice){
            currPrice = `<a  class="price product-popup-link" 
                data-fancybox data-type="ajax"
                data-src="/products/${product.handle}?view=popup">
                <span class="price_sale">$${formatNumberMXN(currvariants[0].compareAtPrice)}</span>
                <span class="price_regular">$${formatNumberMXN(finalPrice)}</span>
            </a>`;
            onSale = ` <span class="sale">En oferta</span>`;
        }else{
            currPrice = `<a class="price product-popup-link" 
                data-fancybox data-type="ajax"
                data-src="/products/${product.handle}?view=popup">
                <span class="price_regular">$${formatNumberMXN(finalPrice)}</span>
            </a>`; 
        }

        const totalInventory = currvariants.reduce((variantTotal, variant) => {
            const edges = variant.inventoryItem?.inventoryLevels?.edges || [];

            const variantInventory = edges.reduce((locationTotal, edge) => {
            const quantities = edge.node?.quantities || [];

            const available = quantities.find(q => q.name === 'available');

            return locationTotal + Number(available?.quantity || 0);
            }, 0);

            return variantTotal + variantInventory;
        }, 0);


        if(Number(currvariants[0].inventoryQuantity) > 0){
            availableCount++;
            badgeInventoryQuantity = `<span class="badge-inventory-quantity">${currvariants[0].inventoryQuantity} en existencia</span>`;
        }else{
            soldOut = `<span class="sold">Agotado</span>`;
            buttonShop = `<a  class="soldout product-popup-link"
                data-fancybox data-type="ajax"
                data-src="/products/${product.handle}?view=popup" 
                >
                Agotado
            </a>`;
            //return;
        }
        
        const templateItem = `<div class="custom-products-dimeint__item">
            <a class="product-popup-link" 
                data-fancybox data-type="ajax"
                data-src="/products/${product.handle}?view=popup" 
                >
                <img src="${product.image_src}" alt="${product.title}" width="" height="">
            ${badgeInventoryQuantity}    
            ${onSale}
            ${soldOut}
            </a>
            ${currPrice}
            <a class="description product-popup-link" 
                data-fancybox data-type="ajax"
                data-src="/products/${product.handle}?view=popup" >
                ${product.title} <br />
                <span>${product.marca}</span>
            </a>
        </div> `;

        $("form.live-search-form .search-flydown .search-flydown--results").append(templateItem);

        
    });

    /*if (availableCount === 0) {
        
        console.log("aca no hay")
        $("form.live-search-form .search-flydown .search-flydown--results").html("No se encontraron resultados");
    }*/
}

async function getLoactions(skucustom) {

    const headers = {
        'Content-type': 'application/json'
    };
    
    try{
        const response = await getData(`/apps/folders?type=get_inventory&sku=${skucustom}`, 'GET', headers, '');
        
        let currTotal = 0;
        let sucursalesArr = [];
        response.Response_Existencia.forEach(location => {

            let currSucursal = location.Sucursal;

            switch (location.Sucursal) {
                    case "TOLUCA":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`T:${location.Existencia}`) : '';
                    break;
                case "QUERÉTARO NORTE":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`QN:${location.Existencia}`) : '';
                    break;
                case "CUAUTITLAN":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`C:${location.Existencia}`) : '';
                    break;
                case "MONTERREY":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`M:${location.Existencia}`) : '';
                    break;
                case "VICTORIA":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`V:${location.Existencia}`) : '';
                    break;
                case "QUERÉTARO SUR":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`QS:${location.Existencia}`) : '';
                    break;
                case "GUADALAJARA":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`G:${location.Existencia}`) : '';
                    break;
                case "TOLUCA TEC":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`TT:${location.Existencia}`) : '';
                    break;
                case "CDMX CENTRO":
                    Number(location.Existencia) > 0 ? sucursalesArr.push(`CC:${location.Existencia}`) : '';
                    break;

                default:
                    break;
            }
            
            const templateItem = `<li class="custom-products-dimeint__item">
                ${ currSucursal}: <b> ${location.Existencia.trim()}</b>
            </li> `;

            if(Number(location.Existencia) > 0){
               $("#custom-locations ul").append(templateItem);
            }
            currTotal += Number(location.Existencia);
        });

        $(`input[name="properties[STK]"]`).val(`${sucursalesArr}`);

        if(currTotal){
            $("#custom-locations h4").text(`${currTotal} en existencia`);
        }else{
            $("form.smart-payment-enabled").hide();
            $(".product-form--atc").hide();
            $("#custom-locations h4").text(`Agotado`);

        }
    }catch(err){

    }


}

async function getNewPrices(skuscustom) {


    const headers = {
        'Content-type': 'application/json'
    };
    
    try{
        let userType = $("#customer_type_custom").val();
        const response = await getData(`/apps/folders?type=getprices&userType=${userType}&skus=${skuscustom}`, 'GET', headers, '');

        let totalAll = 0;

        response.forEach(product => {
            let sku = product.sku;
            let price = product.price;

            let currQTYProduct = 0;

            if($(`input[data-item-qty-sku="${sku}"]`).length > 0){
                currQTYProduct = Number($(`input[data-item-qty-sku="${sku}"]`).val())
            }else if($(`select[data-item-qty-sku="${sku}"]`).length > 0){
                currQTYProduct = Number($(`select[data-item-qty-sku="${sku}"]`).val())
            }
            
            totalPerProduct = Number(price) * currQTYProduct;

            let $span = $(`span[data-custom-sku="${sku}"]`);

            if ($span.length > 0) {
                $span.text(`$${formatNumberMXN(price)}`); 
            }

            if($(".cart-title-total-custom").length > 0){
                totalAll += totalPerProduct;
                $(`.cart-item--total-per-product[data-item-sku-per-product="${sku}"]`).text(`$${totalPerProduct.toFixed(2)}`);
            }

        });

        if($(".cart-title-total-custom").length > 0){
            $(".cart-title-total-custom").text(`$${totalAll.toFixed(2)}`);
        }

        let match = response.find(item => item.sku === sku);

        
    }catch(err){ 

    }
    
}

$(function(){

    let $divs = $("span[data-custom-sku]");
    let $skusCustom = '';
    if ($divs.length > 0) {
        $divs.each(function(index) {
            let sku = $(this).data("custom-sku");
            $skusCustom += sku;
            if (index < $divs.length - 1) $skusCustom += ',';
        });
        
    } 

    if ($divs.length > 0) {
        getNewPrices($skusCustom)
    }

    
    
    /*Fancybox.bind(".product-popup-link", {
        type: "ajax",
        ajax: {
            settings: {
            data: { popup: true } // param extra por si lo usas en Liquid
            }
        },
        dragToClose: false,
        Toolbar: false,
        smallBtn: true,
        mainClass: "product-fancybox",
    });*/

    $(window).on('scroll', function () {

        const section = $("#shopify-section-products");

        // ✅ Verificar existencia del selector antes de usar offset()
        if (!section.length) return;

        const scrollBottom = $(window).scrollTop() + $(window).height();
        const containerBottom = section.offset().top + section.outerHeight();

        let jsonCustomInfo = localStorage.getItem("current_info");

        if (scrollBottom + 100 >= containerBottom) {

            let parsedData = JSON.parse(jsonCustomInfo);
            if(parsedData.currBrand){

                let titleCategory = $(`a[data-id="${parsedData.currBrand}"]`).parent("li").parent("ul").parents("li.custom-has-children.first").find("a.first").attr("data-title") || "";
                let titleSubCategory = $(`a[data-id="${parsedData.currBrand}"]`).parent("li").parent("ul").prev().attr("data-title") || "";
                let titleBrand = $(`a[data-id="${parsedData.currBrand}"]`).attr("data-title") || "";

                if(titleBrand == "all"){
                    titleBrand = "Todos los productos";
                }

                let currActiveOffer = localStorage.getItem("curr_type_offer");

                if(titleBrand == "Todos los productos"){
                    if(parsedData.currBrand == "all" && parsedData.currText.length > 0){
                        getProducts(`all&query=${parsedData.currText}&remates=${currActiveOffer}`, "load");
                    } else {
                        getProducts(`all&remates=${currActiveOffer}`, "load");
                    }
                } else {
                    
                    if($(`a[data-id="${parsedData.currBrand}"]`).hasClass("second")){
                        let titleSubCategory = $(`a[data-id="${parsedData.currBrand}"]`).attr("data-title") || "";
                        getProducts(`getsubgrupo&grupo=${titleCategory}&subgrupo=${titleSubCategory}&remates=${currActiveOffer}`, "load");
                    }else{
                        getProducts(`getbrand&marca=${titleBrand}&grupo=${titleCategory}&subgrupo=${titleSubCategory}&remates=${currActiveOffer}`, "load");
                    }
                    
                }
            }
        }
    });

    const $input = $('form.live-search-form input.live-search-form-field');
    const $button = $('form.live-search-form  button.live-search-button');

    let debounceTimer;
    
    $input.on('input', function () {
        clearTimeout(debounceTimer);

        $("form.live-search-form .search-flydown .search-flydown--results").html("Cargando...");
        $("#custom-all-productst").remove();
        debounceTimer = setTimeout(function () {
            let currFilterDate = $("#SortBy").val();
            let currSilo = "all";
            let currText = $input.val().trim();
            if(currText.length > 0){
                $("form.live-search-form .search-flydown").addClass("active");
            }else{
                $("form.live-search-form .search-flydown").removeClass("active");
            }
            let currentInfo = {
                currText: $input.val().trim(),
                currBrand: "all",
            };

            localStorage.setItem("current_info", JSON.stringify(currentInfo));
            getProductsSearch(`all&query=${currText}&remates=2`, "search");
            
        }, 500);
    });

   $input.on('blur', function (e) {
        setTimeout(function(){
            if (!$(e.relatedTarget).closest('.live-search').length) {
                $("form.live-search-form .search-flydown").removeClass("active");
            }
        }, 500);
    });

    $input.on('focus', function () {
        let currText = $input.val().trim();
        if(currText.length > 0){
            $("form.live-search-form .search-flydown").addClass("active");
            getProductsSearch(`all&query=${currText}&remates=2`, "search");
        }else{
            $("form.live-search-form .search-flydown").removeClass("active");
        }
    });

    // Prevenir comportamiento por defecto del botón
    $button.on('click', function (e) {
        e.preventDefault();
        if($input.val().trim().length > 0){
            let currentInfo = {
                currText: $input.val().trim(),
                currBrand: "all",
            };

            localStorage.setItem("current_info", JSON.stringify(currentInfo));
            localStorage.setItem("is_page_search", 1);
            window.location.href = "/pages/productos";
        }
    });

    // Si hay foco en el input y se presiona Enter, simular clic en el botón
    $input.on('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            $button.trigger('click');
        }
    });

    $(document).on('click', '#custom-all-productst', function (e) {
        e.preventDefault();
        $button.trigger('click');
    });

    $(document).on('click', '.custom-products-dimeint__item .product-popup-link', function (e) {
        let currSku = $(this).attr("data-sku");
    });

    $(document).on("mousemove", function(e) {
        if (e.clientX <= 0 && !$("body").hasClass("active-categories-custom")) {
            $(".navmenu-id-categorias").trigger("click");
        }
    });

    $(document).on('click', '#custom-open-categories', function (e) {
        if (!$("body").hasClass("active-categories-custom")) {
            $(".navmenu-id-categorias").trigger("click");
        }
    });
    

});
